module.exports = __webpack_public_path__ + "img/img-chart-03.70702ff8.png";